import { render, staticRenderFns } from "./FastestGrowingModels.vue?vue&type=template&id=5eff53de&"
import script from "./FastestGrowingModels.vue?vue&type=script&lang=js&"
export * from "./FastestGrowingModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports